import { DataWrapper } from 'components/patterns/suspense/internals/types'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { ArticleGridMode, configs } from 'experiences/learn/articles/ArticleGrid/config'
import { BlockComponent } from 'lib'
import React from 'react'
import { ArticleCard, SuspensefulArticleCard } from 'experiences/learn/articles/ArticleCard'

interface ArticleSwitchProps {
	articleData: ArticleSummary
	gridMode: ArticleGridMode
}
const ArticleComponentSwitch: BlockComponent<ArticleSwitchProps> = ({ articleData, gridMode }) => {
	const { Component, cardMode } = configs[gridMode]
	return (
		<Component>
			<ArticleCard article={articleData} mode={cardMode} />
		</Component>
	)
}

interface ArticleSwitchPropsAsync {
	articleData: DataWrapper<ArticleSummary>
	gridMode: ArticleGridMode
}
const ArticleComponentSwitchAsync: BlockComponent<ArticleSwitchPropsAsync> = ({ articleData, gridMode }) => {
	const pendingData = articleData.fork(article => ({ article }))
	const { Component, cardMode } = configs[gridMode]
	return (
		<Component>
			<SuspensefulArticleCard data={pendingData} mode={cardMode} />
		</Component>
	)
}

export const generateItems = (mode: ArticleGridMode, articles: Array<ArticleSummary>) =>
	articles.map(article => <ArticleComponentSwitch articleData={article} gridMode={mode} key={article.id} />)

export const generateItemsAsync = (mode: ArticleGridMode, articles: Array<DataWrapper<ArticleSummary>>) =>
	articles.map(article => <ArticleComponentSwitchAsync articleData={article} gridMode={mode} key={article.getId()} />)
